// src/api/config.ts
import { loadEnvConfig } from '../config/env';

class ApiConfig {
  private static baseUrl: string | null = null;

  public static async getBaseUrl(): Promise<string> {
    if (!this.baseUrl) {
      const envConfig = await loadEnvConfig();
      this.baseUrl = envConfig.REACT_APP_API_BASE_URL;
      
      if (!this.baseUrl) {
        throw new Error('API base URL is not configured in environment');
      }
    }
    return this.baseUrl;
  }
}

// Export a function that uses the static method
export const getApiBaseUrl = () => ApiConfig.getBaseUrl();
